// Configuration object that will be exposed globally
const DEFAULT_CONFIG = {
  clientId: '124906348260-32d6qsuud7kugi7403jec6k6ki0ov2k0.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/spreadsheets',
  features: {
    enableLocalBackupDownload: false
  },
  // Master Google Spreadsheet ID (all tables are sheets/tabs within this one spreadsheet)
  masterSpreadsheet: '1E5pp5i6WQc_e9Fm3L8o_pxCsccQJaMXtlSZMFGEDlpk',

  // Mapping of Unity table names to sheet configurations within master spreadsheet
  tableSheets: {
    'Topic 1': {
      sheetId: 1984979897,
      sheetName: 'Topic 1'
    },
    'Extras': {
      sheetId: 940255048,
      sheetName: 'Extras'
    }
    // Add more table-to-sheet mappings as needed
  },

  // References table configuration
  referencesTable: {
    sheetId: 0, // gid for References sheet (update this with actual gid from Google Sheets URL)
    sheetName: 'References',
    columns: {
      referenceTag: 'Reference Tag',  // Column with tags like "[Sam 2025]"
      reference: 'Reference',         // Column with full reference text
    }
  },

  // Language configuration
  languages: {
    // Default languages to use in the editor (MUST match Unity's actual locale names)
    defaultLanguages: ['English (en)', 'Portuguese (Brazil) (pt-BR)'],
    // Mapping from Unity language names to Google Sheets column names
    // The key is what Unity uses (with country codes), the value is what's in the Google Sheets header
    columnMapping: {
      'English (en)': 'English(en)',
      'Portuguese (Brazil) (pt-BR)': 'Portuguese (Brazil)(pt-BR)'
    }
  },
};

// Type for the config
type ConfigType = typeof DEFAULT_CONFIG;

// Expose on window object for runtime editing
declare global {
  interface Window {
    APP_CONFIG?: ConfigType;
  }
}

// Helper function to get the active config (runtime-editable or default)
export function getConfig(): ConfigType {
  if (typeof window !== 'undefined' && window.APP_CONFIG) {
    return window.APP_CONFIG;
  }
  return DEFAULT_CONFIG;
}

// For backwards compatibility - returns runtime config if available
export const GOOGLE_CONFIG: ConfigType = new Proxy({} as ConfigType, {
  get(target, prop) {
    return getConfig()[prop as keyof ConfigType];
  }
});

// Initialize window.APP_CONFIG if in browser
if (typeof window !== 'undefined' && !window.APP_CONFIG) {
  window.APP_CONFIG = DEFAULT_CONFIG;
}
